import {useQuery} from '@tanstack/react-query'
import fetch from 'cross-fetch'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getMrtApiBasepath} from '../ssr/helpers'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'

const useHelpMeChooseSurvey = ({parameters}, requestOptions) => {
    const {locale} = useMultiSite()
    const origin = useAppOrigin()

    async function getSurvey({id}) {
        const endpoint = origin + getMrtApiBasepath('/get-survey-json?id=' + id)

        try {
            const response = await fetch(endpoint)

            if (!response.ok) {
                throw new Error('Network response was not ok')
            }
            const data = await response.text()
            const match = data.match(/__jp0\((.*)\);/)

            if (!match) {
                throw new Error('invalid JSONP response')
            }

            return JSON.parse(match[1])
        } catch (error) {
            console.error('Fetch error:', error)
            return null
        }
    }

    return useQuery(
        ['getSurveyJSData', parameters.id, locale.id],
        () => getSurvey(parameters),
        requestOptions,
    )
}

export default useHelpMeChooseSurvey
